/**
 * Created by johnp on 28/06/2019.
 */

import Vue from 'vue';
import {pickBy} from 'lodash';
import { SectionsListConfig }  from '../../../../author/pagesbuilder/components/editing-sideform/config/SectionsListConfig.js'

const initialState = () => {
	return  {
		sectionFocusModeId: "", //holds id of section with focus mode active (rest of the page is obscured)
		sectionStates: {}, //holds all section  instances in the form of { sectionId : state, ...}
		sectionsData: {}, //holds all data for each section
		sectionsLoaded: false,
		sectionStateToInsertAfter: null,
		sectionManagerInitFlag: false , //flag that starts the section parsing/registering process
		sectionManagerWrapper: null, //node with the wrapper that is parsed to init sections, used by sections manager
		registeredSections : [], //keeps track of all sections (existing / newly inserted),  used by the section factory,
		magicTemplateInitialData : {},
		magicTemplateData : {

		}, //holds info for magic templates
		pasteableSectionData: {},
		sectionCategoryMapping : { // mapping of each section template id with the corresponding section category
			"CourseOverview": ["cour-tpl97","courseHero2"],
			"BundleOverview": [
				"bun-tpl97",
				"tpl-bundle-hero-3", "tpl-bundle-hero-4",
				"tpl-bundle-contents-1", "tpl-bundle-contents-2",
				"tpl-bundle-cta-1", "tpl-bundle-cta-2", "tpl-bundle-cta-3",
				"tpl-bundle-data-1", "tpl-bundle-data-2", "tpl-bundle-data-3",
			],
			"SubscriptionOverview": ["sub-tpl97", "tpl-subscription-contents-1","tpl-subscription-contents-2","tpl-subscription-purchase-1"],
			"ThankYou": ["Thankyou1"],
			"topbar": [
				// "tpl49","tpl50","tpl51","tpl52",
				'topbar1','topbar2','topbar3','topbar4','topbar5','topbar6','topbar7'],
			"footer": ["tpl44","tpl45","tpl47","tpl48"],
			"html": [] //by default any non declared templateId's are html sections
		},
		sectionCategories : SectionsListConfig,


	};
};

export default {
	namespaced : true,
	state: {
		...initialState()
	},
	getters: {
		pasteableSectionAvailable ( state ) {
			return typeof state.pasteableSectionData.sectionData !== "undefined"
		},
		sectionCategories (state, getters, rootState, rootGetters) {
			const displaySection = rootGetters['authoringSettings/displaySection'];
			return pickBy(state.sectionCategories, (val, key) => {
				return displaySection(key);
			})
		},

		getSectionOrders (state,getters,rootState) {
			return function(excludes) {
				let sections = document.querySelector("#pageContent").querySelectorAll(`.${rootState.classSelectors.sectionNode}`);
				const sectionsOrder = [];
				let count = 0;
				sections.forEach((section) => {
					const sectionId = section.getAttribute("id");
					const sectionState = state.sectionStates[sectionId];

					if (!sectionState) { return false;}
					if (excludes.includes('topbar') && sectionState.isTopbar) { return false; }
					if (excludes.includes('footer')  && sectionState.isFooter) { return false; }

					++count;
					sectionsOrder[sectionId] = count;
				});

				return sectionsOrder;
			}
		},

		getPageSections (state, getters) {
			let dataToReturn = [];

			const sectionsOrder = getters.getSectionOrders(['topbar', 'footer']);

			const sectionsSorted = Object.keys(state.sectionStates)
				.filter(sectionId => sectionsOrder.hasOwnProperty(sectionId))
				.sort((a, b) => sectionsOrder[a] - sectionsOrder[b]);

			let count = 0;
			sectionsSorted.forEach( sectionNodeId => {
				let sectionState = state.sectionStates[sectionNodeId];

				count++;
				let anchorName = sectionState.getAnchorName();

				if (!anchorName) {
					if (count === 1 ) {
						anchorName = count + "st";
					} else if (count === 2 ) {
						anchorName = count + "nd";
					} else if (count === 3 ) {
						anchorName = count + "rd";
					} else {
						anchorName = count + "th";
					}
				}

				dataToReturn.push({label: anchorName , value: sectionNodeId});
			});

			if (!dataToReturn.length) {
				dataToReturn.push({ label : "No sections found " , value : "", disabled : true});
			} else {
				dataToReturn.unshift({ label : "Select section " , value : "", disabled : true});
			}

			return dataToReturn;
		},
	},
	actions : {
		setMagicTemplateInitialData ( {commit} , payload) {
			commit('setMagicTemplateInitialData' , payload);
		},
		removeMagicTemplateData ( {commit} , payload) {
			commit('removeMagicTemplateData' , payload);
		},
		setSectionData ( { commit } , payload ) {
			commit('setSectionData', payload);
		},
		registerSection ( {commit } , payload) {
			commit('registerSection', payload);
		},
		editRegisteredSection ( { commit } , payload) {
			commit('editRegisteredSection', payload);
		},
		unregisterSection ( { commit } , payload) {
			commit('unregisterSection', payload);
		},
		addSectionState ( { commit } , payload) {
			commit('addSectionState', payload);
		},
		setSectionManagerInitFlag ( { commit } , payload) {
			commit('setSectionManagerInitFlag', payload);
		},
		setSectionManagerWrapper ( {commit} , payload) {
			commit('setSectionManagerWrapper', payload);
		},
		initSectionsManager ( {commit} , payload) {
			commit('setSectionManagerWrapper',payload)
			commit('setSectionManagerInitFlag',true)
		},
		clearCurrentPageData( {commit} ){
			commit('clearCurrentPageData');
		},
		setPasteableSectionData ( {commit} , payload) {
			commit('setPasteableSectionData', payload);
		},
		setSectionStateToInsertAfter ( { commit } , payload ) {
			commit('setSectionStateToInsertAfter', payload);
		},
		setSectionFocusMode ( { commit } , payload) {
			commit('setSectionFocusMode', payload);
		},
		removeSectionState ( { commit } , payload) {
			commit('removeSectionState', payload);
		},
		removeSectionData ( {commit},payload) {
			commit('removeSectionData', payload);
		},
		removeAllSectionData ( { commit , dispatch} , payload) {
			dispatch('removeSectionData', payload);
			dispatch('removeSectionState', payload);
		},
		setSectionsData( { commit } , payload) {
			commit('setSectionsData', payload);
		},
		setMagicTemplateElementData( { commit } , payload) {
			commit('setMagicTemplateElementData', payload);
		},
		setMagicTemplateComponentData( { commit } , payload) {
			commit('setMagicTemplateComponentData', payload);
		},
		setMagicTemplateSectionData( { commit } , payload) {
			commit('setMagicTemplateSectionData', payload);
		},

	},
	mutations : {
		setMagicTemplateInitialData ( state , data) {
			if (!data) {
				return;
			}

			if (!data.sectionId) {
				return;
			}

			Vue.set(state.magicTemplateInitialData,data.sectionId, copyJson(data));
			Vue.set(state.magicTemplateData,data.sectionId, data);
		},
		setMagicTemplateSectionData (state , data) {
			if (typeof state.magicTemplateData[data.sectionId] !== "undefined") {
				// Vue.set(state.magicTemplateData, data.sectionId, {});
				// if (typeof state.magicTemplateData[data.sectionId].data === "undefined") {
				// 	Vue.set(state.magicTemplateData[data.sectionId], "data", {});
				// }
				//
				// if (typeof state.magicTemplateData[data.sectionId].data.sectionData === "undefined") {
				// 	Vue.set(state.magicTemplateData[data.sectionId].data, "sectionData", {});
				// }

				Vue.set(state.magicTemplateData[data.sectionId].data.sectionData, "myClone" , data.sectionClone);

				for (let key in data.sectionData) {

					if (!data.sectionData.hasOwnProperty(key)) {
						continue;
					}

					Vue.set(state.magicTemplateData[data.sectionId].data.sectionData.myData, key , data.sectionData[key]);
				}
			}
		},
		setMagicTemplateElementData ( state , data) {
			if (typeof state.magicTemplateData[data.sectionId] !== "undefined" && state.magicTemplateData[data.sectionId].data && state.magicTemplateData[data.sectionId].data.elementData) {
				for (let key in data.elementData) {

					if (!data.elementData.hasOwnProperty(key)) {
						continue;
					}

					// if an element tries to set its magic data but there's no entry for it look for an existing element  of the similar type and replace its data ,
					if (typeof state.magicTemplateData[data.sectionId].data.elementData[data.elementId] === "undefined") {
						Vue.set(state.magicTemplateData[data.sectionId].data.elementData,data.elementId,{});
					}

					Vue.set(state.magicTemplateData[data.sectionId].data.elementData[data.elementId],key,data.elementData[key]);
				}
			}
		},
		setMagicTemplateComponentData ( state , data) {
			if (typeof state.magicTemplateData[data.sectionId] !== "undefined" && state.magicTemplateData[data.sectionId].data && state.magicTemplateData[data.sectionId].data.componentData ) {
				for (let key in data.componentData) {

					if (!data.componentData.hasOwnProperty(key)) {
						continue;
					}

					if (typeof state.magicTemplateData[data.sectionId].data.componentData[data.componentId] === "undefined") {
						Vue.set(state.magicTemplateData[data.sectionId].data.componentData,data.componentId,{});
					}

					Vue.set(state.magicTemplateData[data.sectionId].data.componentData[data.componentId],key,data.componentData[key]);
				}
			}
		},
		removeMagicTemplateData ( state , sectionId) {
			if (typeof state.magicTemplateData[sectionId] !== "undefined") {
				Vue.delete(state.magicTemplateData,sectionId);
			}
		},
		addSectionState ( state , data) {
			Vue.set(state.sectionStates,data.sectionId,data.state)
		},
		registerSection ( state , registrationData) {
			state.registeredSections.push(registrationData)
		},
		editRegisteredSection (state,data) {

			if (data.action === "replaceTempId") {
				state.registeredSections.map ( (sectionData,index) => {
					if (data.tempId && sectionData.tempId === data.tempId) {
						// delete sectionData.tempId;
						sectionData.sectionId = data.sectionId;
					}
				});
			}
		},
		unregisterSection ( state , sectionId) {

			state.registeredSections.map ( (sectionData,index) => {
				if (sectionData.sectionId === sectionId) {
					Vue.delete(state.registeredSections,index);
				}
			});
		},
		setSectionData ( state , data) {

			if (data) {

				if (typeof state.sectionsData[data.sectionId] === "undefined") {
					Vue.set(state.sectionsData, data.sectionId, data);
				}

				for (let key in data) {

					if (!data.hasOwnProperty(key) || key === "sectionId") {
						continue;
					}

					Vue.set(state.sectionsData[data.sectionId], key, data[key]);
				}

			}
		},
		removeSectionState ( state , sectionId) {
			if (typeof state.sectionStates[sectionId] !== "undefined") {
				Vue.delete(state.sectionStates, sectionId);
			}
		},
		removeSectionData ( state ,sectionId) {
			if (typeof state.sectionsData[sectionId] !== "undefined") {
				Vue.delete(state.sectionsData, sectionId);
			}
		},
		setPasteableSectionData ( state , sectionData) {
			state.pasteableSectionData = sectionData;
		},
		setSectionStateToInsertAfter ( state , sectionState ) {
			state.sectionStateToInsertAfter = sectionState;
		},
		setSectionFocusMode ( state , sectionId) {
			state.sectionFocusModeId = sectionId; // resets with empty string
		},
		setSectionManagerInitFlag (state , flag) {
			state.sectionManagerInitFlag = flag
		},
		setSectionManagerWrapper ( state , wrapper ) {
			state.sectionManagerWrapper = wrapper
		},
		setSectionsData ( state, pageData) {
			state.sectionsLoaded = true;
			state.sectionsData = pageData && pageData.sections  && !Array.isArray(pageData.sections)? pageData.sections : {};
		}

	}
}